module.exports = __webpack_public_path__ + "img/DefaultLight.72f92869.svg";